import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Shop from '../views/Shop.vue'
import ProductDetail from '../views/ProductDetail.vue'
import Cart from '../views/Cart.vue'
import NotFound from '../views/PageNotFound.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: 'Bees Atelier | Handcrafted Gifts with Love' }
  },
  {
    path: '/shop',
    name: 'Shop',
    component: Shop,
    meta: { title: 'Bees Atelier | Handcrafted Gifts with Love' }
  },
  {
    path: '/shop/:slug?',
    name: 'ShopBySlug',
    component: Shop,
    meta: { title: 'Bees Atelier | Handcrafted Gifts with Love' }
  },
  {
    path: '/product/:slug',
    name: 'Product Detail',
    component: ProductDetail,
    meta: { title: 'Bees Atelier | Handcrafted Gifts with Love' }
  },
  {
    path: '/cart',
    name: 'Cart',
    component: Cart,
    meta: { title: 'Bees Atelier | Handcrafted Gifts with Love' }
  },
  {
    // path: "*",
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: NotFound,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { top: 0 }
  },
})
router.afterEach((to, from) => {
  document.title = to.meta.title;
});
export default router
